import { useCallback, useEffect, useState } from 'react';

export const EMPTY_PERSON_FILTERS = {
  person: '',
  q: '',
};

/**
 * Filters for person-list metric drill-downs (in both, only Oracle, only ADP, etc.).
 */
export function usePersonFilters({ enabled, refreshKey = 0, metric = '' }) {
  const [filters, setFilters] = useState({ ...EMPTY_PERSON_FILTERS });
  const [applied, setApplied] = useState({ ...EMPTY_PERSON_FILTERS });

  const clearAllFilters = useCallback(() => {
    setFilters({ ...EMPTY_PERSON_FILTERS });
    setApplied({ ...EMPTY_PERSON_FILTERS });
  }, []);

  const applyFilters = useCallback(() => {
    setApplied({ ...filters });
  }, [filters]);

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  useEffect(() => {
    if (!enabled) {
      clearAllFilters();
      return;
    }
  }, [enabled, clearAllFilters]);

  useEffect(() => {
    clearAllFilters();
  }, [refreshKey, metric, clearAllFilters]);

  const hasPendingApply = JSON.stringify(filters) !== JSON.stringify(applied);
  const hasActiveFilters = Object.values(applied).some((v) => v != null && String(v).trim() !== '');

  return {
    filters,
    applied,
    updateFilter,
    applyFilters,
    clearAllFilters,
    hasPendingApply,
    hasActiveFilters,
  };
}
